import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'salary-advance',
  children: {
    requests: {
      size: 'full',
      path: 'requests',
    },
    employees: {
      size: 'full',
      path: 'employees',
    },
  },
} as const satisfies Location
